/**
 * Check if window.history is supported
 * @returns {boolean} True if window.history is supported, false otherwise
 */
function historyState() {
  return window.history && window.history.replaceState;
}

/**
 * Get the value of a url parameter
 * @param {string} name - The name of the parameter
 * @returns {string | null} The value of the parameter
 */
function getParam(name) {
  if ('URLSearchParams' in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp('[?&]' + name + '=([^&#]*)').exec(
      window.location.href
    );
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.variantInputs = this.querySelectorAll('.product__variant-input');
    this.cartButton = this.querySelector('.product__add-to-cart');
    this.requestAvailabilityButton = this.querySelector(
      '.product__add-to-cart.archival'
    );
  }

  connectedCallback() {
    this.variantInputs.forEach((variantInput) => {
      variantInput.addEventListener(
        'change',
        this.handleVariantChange.bind(this)
      );
    });

    this.setFromSearchParam();
  }

  setFromSearchParam() {
    const variantId = getParam('variant');
    if (variantId) {
      this.variantInputs.forEach((variantInput) => {
        if (variantInput.value === variantId) {
          variantInput.checked = true;

          if (variantInput.dataset.available === 'false') {
            this.cartButton.disabled = true;
          } else {
            this.cartButton.disabled = false;
          }
        }
      });

      // If no variant has been selected initially, this class was added. Remove it once we select a variant.
      this.cartButton.classList.remove('unselected');
    }
  }

  handleVariantChange(event) {
    const variantInput = event.target;

    if (variantInput.dataset.available === 'false') {
      this.cartButton.disabled = true;

      // If no variant has been selected initially, this class was added. Remove it once we select a variant.
      this.cartButton.classList.remove('unselected');
    } else {
      this.cartButton.disabled = false;
    }

    if (this.requestAvailabilityButton) {
      const href = this.requestAvailabilityButton.getAttribute('href');

      if (href && variantInput.value) {
        const url = new URL(href, window.location.origin);

        url.searchParams.set('variant', variantInput.value);
        this.requestAvailabilityButton.setAttribute(
          'href',
          url.pathname + url.search + url.hash
        );
      }
    }

    // Append the variant ID as a url parameter
    if (variantInput.value != undefined) {
      if (historyState()) {
        window.history.replaceState(
          {},
          document.title,
          '?variant=' + variantInput.value
        );
      }
    }
  }
}

customElements.define('product-form', ProductForm);
